import { Component } from '@angular/core';

@Component({
  selector: 'allas-banner-principal-baterias',
  imports: [],
  template: `<section
    id="banner-principal-baterias"
    class="grid grid-cols-12 bg-cover bg-center bg-no-repeat fs-condensed"
  >
    <div
      class="flex flex-col gap-2 col-span-12 xl:col-span-8 xl:col-start-4 xl:col-end-8 p-4 xl:p-6 xl:py-16 justify-center items-center mt-48 xl:mt-0"
    >
      <main class="flex flex-col gap-0 xl:gap-2">
        <span class="text-white text-sm xl:text-2xl text-center">
          DIAGNOSTICO, CARGA E INSTALACIÓN
        </span>
        <span
          class="text-white text-3xl xl:text-6xl font-bold fs-condensed text-center"
        >
          GRATIS DE <br class="hidden xl:block" />
          BATERÍAS
        </span>
        <div class="flex gap-2 self-center mt-2 xl:mt-6">
          <a
            href="https://wa.me/50495089953?text=Hola,%20necesito%20cotizar%20una%20batería.%20¿Podrían%20ayudarme?"
            class="text-xs xl:text-base bg-white text-[#e0040e] px-4 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
          >
            CONTACTAR +504 9508-9953
          </a>
          <a
            href="/repuestos/bateria-para-carro-auto-o-camioneta"
            class="text-xs xl:text-base border-white border text-white px-4 py-2 rounded-md font-medium fs-condensed hover:scale-105 transition-all duration-300"
          >
            COMPRAR AHORA
          </a>
        </div>
      </main>
    </div>
  </section>`,
  styles: [
    `
      section#banner-principal-baterias {
        background-image: url('/images/services/diagnostico-instalacion-baterias/banner-principal-responsive.webp') !important;
        background-size: cover;
        background-position: center;
      }

      @media (min-width: 1280px) {
        section#banner-principal-baterias {
          background-image: url('/images/services/diagnostico-instalacion-baterias/banner-principal.webp') !important;
        }
      }
    `,
  ],
})
export class BannerPrincipalBaterias {}
